import { EluveError } from './eluve-error';
import { LogLevel } from './types';

export const TRANSIENT_ERROR_CAUSES = {
  LLM_OUTPUT_PARSE_FAILURE: 'Failed to parse llm output',
  LLM_SCHEMA_VALIDATION_FAILURE: 'LLM output schema validation failed',
  TRANSCRIPTION_TIMEOUT: 'Transcription initialization timeout',
  LLM_GENERATION_FAILURE: 'Failed to generate LLM output',
  APPOINTMENT_TAG_FK_VIOLATION:
    'Appointment tags FK constraint violation on file_id',
} as const;

type TransientErrorCause =
  | (typeof TRANSIENT_ERROR_CAUSES)[keyof typeof TRANSIENT_ERROR_CAUSES]
  | (string & {});

export class TransientError extends EluveError {
  static override readonly errorName = 'TransientError';
  readonly logLevel: LogLevel = 'warn';

  constructor(cause: TransientErrorCause, meta?: Record<string, unknown>) {
    super(cause, { metadata: meta });
  }
}
